import { Listing } from './types/Listing';
import { MakeCall } from './createMakeCall';

export interface DuplicateListingPayload {
  asCharitable?: boolean;
}

const duplicateListing =
  (makeCall: MakeCall) =>
  (listingId: number, data: DuplicateListingPayload = {}) => {
    return makeCall<Listing>('POST', `/api/v2/listing/${listingId}/copy`, {
      data,
    });
  };

export type DuplicateListingCall = (
  listingId: number,
) => Promise<{ data: Listing }>;
export { duplicateListing };
